import React from "react";
import MKButton from "components/MKButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const IdleTimeOutModal = (props) => {
  const { show, open, focusAfterClose, handleContinue, handleLogout } = props;

  const [seconds, setSeconds] = React.useState(30);

  React.useEffect(() => {
    if (show) {
      if (seconds > 0) {
        setTimeout(() => setSeconds(seconds - 1), 1000);
      } else {
        handleLogout();
      }
    }
  });

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={handleContinue}
      >
        <DialogTitle id="alert-dialog-title" onClose={handleContinue}>
          You Have Been Idle!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your session is about to expire in{" "}
            <span style={{ color: "red" }}> {seconds} </span> seconds due to
            inactivity. You will be redirected to the login page
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MKButton variant="gradient" color="info" size="small" onClick={handleLogout}>
            {/* <Button variant="contained" color="info" size="small" onClick={handleLogout}> */}
            Logout
          </MKButton>
          <MKButton variant="gradient" color="info" size="small" onClick={handleContinue} autoFocus>
          {/* <Button variant="contained" color="info" size="small" onClick={handleContinue} autoFocus > */}
            Continue Session
          </MKButton>
        </DialogActions>
      </Dialog>
      {/* <Dialog
        onClose={handleContinue}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        open={open}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title" onClose={handleContinue}>
          You Have Been Idle!
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            Your session is about to expire in{" "}
            <span style={{ color: "red" }}> {seconds} </span> seconds due to
            inactivity. You will be redirected to the login page
          </Typography>
        </DialogContent>
        <DialogActions>
          <MKButton autoFocus onClick={handleLogout} variant="gradient" color="info" size="small">
            Logout
          </MKButton>
          <MKButton autoFocus onClick={handleContinue} variant="gradient" color="info" size="small">
            Continue Session
          </MKButton>
        </DialogActions>
      </Dialog> */}
    </>
  );
};

export default IdleTimeOutModal;
